import type { BannerItem } from "$root/components/banner-stack/types";
import type { Instrument } from "../const";

export function normalisedInvestmentInstrumentBanner({ rows }: { rows: Instrument[] }): BannerItem | null {
	if (!rows.some((instrument) => instrument.someInstrumentsAreExcluded)) {
		return null;
	}

	return {
		id: "normalised-investment-instrument",
		severity: "info",
		title: "Instruments with a normalised weight <0.01% will be excluded from the new portfolio.",
		description:
			"The new portfolio contains instruments with a normalised weight lower than 0.01%. Due to the low weight, these instruments have become irrelevant and will be excluded. If you wish to include all instruments, you can add them manually or increase the weight of the highlighted portfolio or instruments here below.",
		dismissible: true,
	};
}
